<ng-casto-desktop-configurator-template
  [steps]="steps"
  [currentStepId]="currentStepId"
  [preview]="preview"
  [actions]="actions"
  [panelCollapsed]="panelCollapsed"
  (stepSelected)="onStepSelected($event)"
  (panelCollapsedChange)="onPanelCollapsedChange($event)">
</ng-casto-desktop-configurator-template>
